import { UseFormWatch } from "react-hook-form";
import { TCreateCOSHH } from "../types";
import { format } from "date-fns";

interface SummaryStepProps {
  watch: UseFormWatch<TCreateCOSHH>;
}

const SummaryStep = ({ watch }: SummaryStepProps) => {
  const data = watch();

  return (
    <div className="space-y-6 rounded-xl border border-neutral-200 bg-white p-8">
      <h2 className="text-lg font-Medium text-primary-500">
        COSHH Assessment Summary
      </h2>

      <div className="grid grid-cols-2 gap-y-4 gap-x-8">
        <div>
          <span className="text-sm text-neutral-500 block">Reference</span>
          <span className="font-medium">{data.reference || "-"}</span>
        </div>
        <div>
          <span className="text-sm text-neutral-500 block">Title</span>
          <span className="font-medium">{data.title || "-"}</span>
        </div>
        <div>
          <span className="text-sm text-neutral-500 block">Site</span>
          <span className="font-medium">{data.siteId?.label || "-"}</span>
        </div>
        <div>
          <span className="text-sm text-neutral-500 block">
            Assessment Date
          </span>
          <span className="font-medium">
            {data.assessmentDate
              ? format(data.assessmentDate, "dd/MM/yyyy")
              : "-"}
          </span>
        </div>
      </div>

      <div className="mt-8 border-t border-neutral-200 pt-6">
        <h3 className="font-medium mb-4">
          Chemicals ({data.chemicals?.length || 0})
        </h3>
        <div className="space-y-3">
          {data.chemicals?.map((chem, idx) => (
            <div
              key={idx}
              className="bg-neutral-50 p-4 rounded-lg flex justify-between items-center"
            >
              <div>
                <span className="font-medium block">
                  {chem.chemicalRegisterEntryId?.label || "Unknown Chemical"}
                </span>
                <span className="text-sm text-neutral-500 block mt-1">
                  Route: {chem.routeOfExposure} | Qty: {chem.quantityUsed} |
                  Freq: {chem.frequencyOfUse}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SummaryStep;
